import Swal from "sweetalert2";
import { put, takeLeading } from 'redux-saga/effects';
import * as actionTypes from '../actionTypes';
import { create_about_us, create_privacy_policy, create_refund_policy, create_terms_and_conditions, get_about_us, get_privacy_policy, get_refund_policy, get_terms_and_conditions } from '../../utils/api-routes';
import { getAPI, postAPI } from "../../utils/api-function";

function* getAboutUs() {
    try {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: true });
        const { data } = yield getAPI(get_about_us);
        console.log("Get About Us Saga Response ::: ", data);

        if (data) {
            yield put({ type: actionTypes.SET_ABOUT_US, payload: data?.results?.aboutUs });
        }
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });

    } catch (error) {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
        console.log("Get About Us Saga Error ::: ", error);
    }
}

function* createAboutUs(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);

        const { data } = yield postAPI(create_about_us, payload);
        console.log("Create About Us Saga Response ::: ", data);

        if (data) {
            Swal.fire({ icon: "success", title: 'Success', text: data?.message, showConfirmButton: false, timer: 2000, });
            yield put({ type: actionTypes.GET_ABOUT_US, payload: null });
        }

    } catch (error) {
        Swal.fire({ icon: "error", title: 'Failed', text: "Failed To Update", showConfirmButton: false, timer: 2000 });
        console.log("Create About Us Saga Error ::: ", error);
    }
}

function* getTermsAndCondition() {
    try {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: true });
        const { data } = yield getAPI(get_terms_and_conditions);
        console.log("Get Terms & Condition Saga Response ::: ", data);

        if (data) {
            yield put({ type: actionTypes.SET_TERMS_AND_CONDITION, payload: data?.results?.termsAndCondition });
        }
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });

    } catch (error) {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
        console.log("Get Terms & Condition Saga Error ::: ", error);
    }
}

function* createTermsAndCondition(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);

        const { data } = yield postAPI(create_terms_and_conditions, payload);
        console.log("Create Terms & Condition Saga Response ::: ", data);

        if (data) {
            Swal.fire({ icon: "success", title: 'Success', text: data?.message, showConfirmButton: false, timer: 2000, });
            yield put({ type: actionTypes.GET_TERMS_AND_CONDITION, payload: null });
        }

    } catch (error) {
        Swal.fire({ icon: "error", title: 'Failed', text: "Failed To Update", showConfirmButton: false, timer: 2000 });
        console.log("Create Terms & Condition Saga Error ::: ", error);
    }
}


function* getPrivacyPolicy() {
    try {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: true });
        const { data } = yield getAPI(get_privacy_policy);
        console.log("Get Privacy Policy Saga Response ::: ", data);

        if (data) {
            yield put({ type: actionTypes.SET_PRIVACY_POLICY, payload: data?.results?.privacyPolicies });
        }
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });

    } catch (error) {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
        console.log("Get Privacy Policy Saga Error ::: ", error);
    }
}

function* createPrivacyPolicy(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);

        const { data } = yield postAPI(create_privacy_policy, payload);
        console.log("Create Privacy Policy Saga Response ::: ", data);

        if (data) {
            Swal.fire({ icon: "success", title: 'Success', text: data?.message, showConfirmButton: false, timer: 2000, });
            yield put({ type: actionTypes.GET_PRIVACY_POLICY, payload: null });
        }

    } catch (error) {
        Swal.fire({ icon: "error", title: 'Failed', text: "Failed To Update", showConfirmButton: false, timer: 2000 });
        console.log("Create Privacy Policy Saga Error ::: ", error);
    }
}

function* getRefundPolicy() {
    try {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: true });
        const { data } = yield getAPI(get_refund_policy);
        console.log("Get Refund Policy Saga Response ::: ", data);

        if (data) {
            yield put({ type: actionTypes.SET_REFUND_POLICY, payload: data?.results?.refundPolicy });
        }
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });

    } catch (error) {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
        console.log("Get Refund Policy Saga Error ::: ", error);
    }
}

function* createRefundPolicy(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);

        const { data } = yield postAPI(create_refund_policy, payload);
        console.log("Create Refund Policy Saga Response ::: ", data);

        if (data) {
            Swal.fire({ icon: "success", title: 'Success', text: data?.message, showConfirmButton: false, timer: 2000, });
            yield put({ type: actionTypes.GET_REFUND_POLICY, payload: null });
        }

    } catch (error) {
        Swal.fire({ icon: "error", title: 'Failed', text: "Failed To Update", showConfirmButton: false, timer: 2000 });
        console.log("Create Refund Policy Saga Error ::: ", error);
    }
}

export default function* staticPageSaga() {
    yield takeLeading(actionTypes?.CREATE_ABOUT_US, createAboutUs);
    yield takeLeading(actionTypes?.GET_ABOUT_US, getAboutUs);
    yield takeLeading(actionTypes?.GET_TERMS_AND_CONDITION, getTermsAndCondition);
    yield takeLeading(actionTypes?.CREATE_TERMS_AND_CONDITION, createTermsAndCondition);
    yield takeLeading(actionTypes?.GET_PRIVACY_POLICY, getPrivacyPolicy);
    yield takeLeading(actionTypes?.CREATE_PRIVACY_POLICY, createPrivacyPolicy);
    yield takeLeading(actionTypes?.GET_REFUND_POLICY, getRefundPolicy);
    yield takeLeading(actionTypes?.CREATE_REFUND_POLICY, createRefundPolicy);
}